// 活動條款
'use client';

// 條款
const terms = [
    '本活動由加密城市科技股份有限公司主辦（下稱主辦單位）。',
    '主辦單位保留隨時修改本活動辦法及本活動之權利。參加活動者一旦參加本活動，即視為同意接受本辦法之拘束。',
    '本活動期間請依照活動公告為主，活動截止將不另行通知，截止後仍未使用抽獎券，視同自願放棄。',
    '依中華民國稅法規定，中獎價值在 NT$1,000 (含)元以上者，贈與物品的價值將併入中獎人年度個人綜合所得稅申報。請中獎人配合繳交身分證影印本作為申報依據，以便主辦單位寄發扣繳憑單。若中獎人不願繳交身分證影本，視同放棄中獎資格，且不得異議。',
    '中獎金額超過 NT$20,000元，中獎人應依稅法先行繳交相當於獎品價值 10% 機會中獎之稅金（若中獎人屬於在中華民國境內居住未達 183 日之本國人或外國人，請參照外籍人士之規定扣繳 20% 稅金），並出具繳款收據後，始得領取獎項。若中獎人不願先行繳納本項稅金，視同放棄中獎資格，不得異議。',
    '外籍人士中獎者（即在中華民國境內居住未達 183 日之本國人或外國人），依中華民國稅法應先行繳交相當於獎品價值 20% 機會中獎之稅金，並出具繳款收據與居留證明後，始得領取獎項。若中獎人不願先行繳納本項稅金，視同放棄中獎資格，不得異議。',
    '主辦單位於抽出得獎者後，將依得獎者所提供之聯絡資訊以電子郵件通知得獎者，得獎者應於主辦單位寄送通知郵件後 10 日內提供主辦單位所要求之完整領獎文件，逾期視為棄權。',
    '本活動所有實體贈品寄送範圍限台澎金馬地區。得獎者若無法提供台澎金馬地區內之寄送地址，恕將視為棄權。',
    '主辦單位寄送贈品給每位得獎者，如無法成功投遞導致贈品遭退回時，或若得獎者聯絡資訊有誤以致無法成功聯絡上得獎者，恕將視為自動棄權。',
    '本活動贈品以公佈於活動網站上的資料為準，主辦單位保留更換其他等值獎項之權利。如活動方式及活動獎品有所變動，以活動網站公告為準，不再另行通知。',
    '本活動贈品不得替換、交換、銷售，或是折換現金或其他商品或服務。',
    '如有任何因電腦、網路、電話、技術或不得歸責於主辦單位之事由，而使參加者所寄出或登錄之資料有延遲、遺失、錯誤、或毀損之情況，主辦單位及相關之母公司、關係企業、員工不負任何法律責任，參加者亦不得因此異議。',
    '如因參加本活動或因活動贈品而遭受任何損失，主辦單位及相關之母公司、關係企業、員工、及代理商不負任何責任。',
    '參與活動者視為同意接受本活動之活動辦法與注意事項之規範，如有違反或以惡意之電腦程式或其他違反活動公平性之方式，意圖混淆或影響活動結果者或有違法之行為，一經主辦單位發現或經第三人檢舉，主辦單位得立即取消參參與活動者之兌獎資格。',
    '主辦單位保有最終核准、變更、修改、取消本活動內容與本條款之權利，如有未盡事宜，悉依主辦單位相關規定或解釋，並得隨時補充公告。',
];

const CampaignTerms = () => {
    return (
        <section id="terms" className="bg-[#141414] space-y-[32px]">
            <h3 className="text-[white] border-[white]">活動條款</h3>

            <ul className="space-y-[2px] pl-[20px]">
                {new Array(15).fill(0).map((v, i) => (
                    <li
                        key={'term' + i}
                        className="text-bd4n text-[white] leading-[180%] list-disc"
                    >
                        {terms[i]}
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default CampaignTerms;
